import { render, staticRenderFns } from "./leadsAssign.vue?vue&type=template&id=7d9817c0&"
import script from "./leadsAssign.vue?vue&type=script&lang=js&"
export * from "./leadsAssign.vue?vue&type=script&lang=js&"
import style0 from "./leadsAssign.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports